import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { EventTypes, recordEvents } from './newRelicEvents';
var openWindow = null;
export function popupWindow(url, title, w, h) {
  var screenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  var screenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
  var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  var systemZoom = width / window.screen.availWidth;
  var left = (width - w) / 2 / systemZoom + screenLeft;
  var top = (height - h) / 2 / systemZoom + screenTop;
  var isIE = window.navigator.userAgent.indexOf('MSIE ') > 0 || window.navigator.userAgent.indexOf('Trident') > 0;
  if (isIE) {
    var popupOptions = 'menubar=no,dialog=yes,maximize=yes,width=800,height=600';
    var _popupWindow = window.open(url, 'processingWindow', popupOptions);
    if (_popupWindow) {
      _popupWindow.location.href = 'about:blank';
      _popupWindow.location.href = url + '&flow=popup';
    }
  } else {
    var _openWindow;
    if (openWindow) (_openWindow = openWindow) === null || _openWindow === void 0 ? void 0 : _openWindow.close();
    openWindow = window.open(url, title, "\n      scrollbars=yes,\n      width=".concat(w / systemZoom, ", \n      height=").concat(h / systemZoom, ", \n      top=").concat(top, ", \n      left=").concat(left, "\n      "));
    var blocked = !openWindow || 'closed' in openWindow && openWindow.closed;
    try {
      // @ts-ignore
      openWindow.focus();
    } catch (e) {
      blocked = true;
    }
    if (blocked) {
      recordEvents(_defineProperty({}, EventTypes.popupBlocked, {
        url: url
      }));
    }
  }
}